<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="420px"
    append-to-body
    @closed="reset"
  >
    <el-form label-width="90px" @submit.native.prevent>
      <el-form-item v-if="requireOld" label="原密码">
        <el-input
          v-model="form.oldPassword"
          type="password"
          show-password
          autocomplete="off"
          placeholder="请输入原密码"
        />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input
          v-model="form.newPassword"
          type="password"
          show-password
          autocomplete="off"
          placeholder="请输入新密码"
        />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input
          v-model="form.confirmPassword"
          type="password"
          show-password
          autocomplete="off"
          placeholder="请再次输入新密码"
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { UseUrl } from '../../utils/config'

export default {
  name: 'ManagerPasswordDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 要修改密码的目标用户名
    username: {
      type: String,
      default: ''
    },
    // 修改自己的密码时需要校验原密码
    requireOld: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    title() {
      if (this.requireOld) {
        return '修改我的密码'
      }
      return `重置密码：${this.username}`
    }
  },
  methods: {
    reset() {
      this.form = { oldPassword: '', newPassword: '', confirmPassword: '' }
      this.submitting = false
    },
    async submit() {
      if (this.submitting) return
      const newPassword = String(this.form.newPassword || '').trim()
      const confirmPassword = String(this.form.confirmPassword || '').trim()
      if (!newPassword) {
        this.$message.warning('请输入新密码')
        return
      }
      if (newPassword !== confirmPassword) {
        this.$message.warning('两次输入的新密码不一致')
        return
      }
      if (this.requireOld && !String(this.form.oldPassword || '').trim()) {
        this.$message.warning('请输入原密码')
        return
      }

      this.submitting = true
      try {
        const res = await axios.post(UseUrl + '/manager/user/updatepassword', {
          username: this.username,
          oldPassword: String(this.form.oldPassword || '').trim(),
          newPassword: newPassword
        })
        if (res.data?.success) {
          this.$message.success(res.data?.message || '密码修改成功')
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(res.data?.message || '密码修改失败')
        }
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || '请求失败'
        this.$message.error(msg)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
